// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file upside/opportunities/v1/opportunities.proto (package upside.opportunities.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file upside/opportunities/v1/opportunities.proto.
 */
export const file_upside_opportunities_v1_opportunities: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Core opportunity data model for list views.
 * Mirrors server/datahub/query_builders/opportunities.py
 *
 * @generated from message upside.opportunities.v1.Opportunity
 */
export type Opportunity = Message<"upside.opportunities.v1.Opportunity"> & {
  /**
   * Identifiers and core attributes
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string customer_org_id = 2;
   */
  customerOrgId: string;

  /**
   * @generated from field: string source_record_id = 3;
   */
  sourceRecordId: string;

  /**
   * @generated from field: string source_record_type = 4;
   */
  sourceRecordType: string;

  /**
   * @generated from field: optional string name = 5;
   */
  name?: string;

  /**
   * @generated from field: optional string type = 6;
   */
  type?: string;

  /**
   * @generated from field: optional string stage_name = 7;
   */
  stageName?: string;

  /**
   * ISO-8601 date strings (e.g., "2024-01-15")
   *
   * @generated from field: optional string close_date = 8;
   */
  closeDate?: string;

  /**
   * @generated from field: optional string created_date = 9;
   */
  createdDate?: string;

  /**
   * @generated from field: optional string account_id = 10;
   */
  accountId?: string;

  /**
   * @generated from field: optional bool is_won = 11;
   */
  isWon?: boolean;

  /**
   * @generated from field: optional bool is_closed = 12;
   */
  isClosed?: boolean;

  /**
   * @generated from field: optional double total_amount = 13;
   */
  totalAmount?: number;

  /**
   * @generated from field: optional string record_type_name = 14;
   */
  recordTypeName?: string;

  /**
   * Calculated/annotated fields
   *
   * @generated from field: optional string account_name = 20;
   */
  accountName?: string;

  /**
   * @generated from field: uint32 buying_group_count = 21;
   */
  buyingGroupCount: number;

  /**
   * Touchpoint metrics (server-side annotations)
   *
   * @generated from field: uint32 touchpoint_count = 22;
   */
  touchpointCount: number;

  /**
   * ISO-8601 datetime string for first touchpoint (nullable)
   *
   * @generated from field: optional string first_touchpoint_date = 23;
   */
  firstTouchpointDate?: string;

  /**
   * ISO-8601 datetime string for last touchpoint (nullable)
   *
   * @generated from field: optional string last_touchpoint_date = 24;
   */
  lastTouchpointDate?: string;

  /**
   * Simplified statuses and derived values
   *
   * @generated from field: optional string milestone_status = 40;
   */
  milestoneStatus?: string;

  /**
   * @generated from field: optional string direction_value = 41;
   */
  directionValue?: string;

  /**
   * 'published' or 'pending_approval'
   *
   * @generated from field: optional string milestone_analysis = 42;
   */
  milestoneAnalysis?: string;

  /**
   * @generated from field: optional string milestone_analysis_generation_status = 43;
   */
  milestoneAnalysisGenerationStatus?: string;

  /**
   * 'INBOUND', 'OUTBOUND', 'UNDETERMINED'
   *
   * @generated from field: optional string direction = 44;
   */
  direction?: string;

  /**
   * @generated from field: optional string direction_generation_status = 45;
   */
  directionGenerationStatus?: string;
};

/**
 * Describes the message upside.opportunities.v1.Opportunity.
 * Use `create(OpportunitySchema)` to create a new message.
 */
export const OpportunitySchema: GenMessage<Opportunity> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 0);

/**
 * Row for recent first-time won opportunities (reporting/home widget)
 *
 * @generated from message upside.opportunities.v1.RecentFirstTimeWonOpportunity
 */
export type RecentFirstTimeWonOpportunity = Message<"upside.opportunities.v1.RecentFirstTimeWonOpportunity"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string account_name = 2;
   */
  accountName: string;

  /**
   * @generated from field: string opportunity_id = 3;
   */
  opportunityId: string;

  /**
   * @generated from field: string opportunity_name = 4;
   */
  opportunityName: string;

  /**
   * ISO-8601 date string, e.g. "2024-12-31"
   *
   * @generated from field: string close_date = 5;
   */
  closeDate: string;

  /**
   * @generated from field: double total_amount = 6;
   */
  totalAmount: number;
};

/**
 * Describes the message upside.opportunities.v1.RecentFirstTimeWonOpportunity.
 * Use `create(RecentFirstTimeWonOpportunitySchema)` to create a new message.
 */
export const RecentFirstTimeWonOpportunitySchema: GenMessage<RecentFirstTimeWonOpportunity> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 1);

/**
 * Row for recent opened opportunities (reporting/home widget)
 *
 * @generated from message upside.opportunities.v1.RecentOpenedOpportunity
 */
export type RecentOpenedOpportunity = Message<"upside.opportunities.v1.RecentOpenedOpportunity"> & {
  /**
   * @generated from field: string opportunity_id = 1;
   */
  opportunityId: string;

  /**
   * @generated from field: string opportunity_name = 2;
   */
  opportunityName: string;

  /**
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: string account_name = 4;
   */
  accountName: string;

  /**
   * ISO-8601 date string, e.g. "2024-01-15"
   *
   * @generated from field: string created_date = 5;
   */
  createdDate: string;

  /**
   * @generated from field: bool has_published_milestone_analysis = 6;
   */
  hasPublishedMilestoneAnalysis: boolean;
};

/**
 * Describes the message upside.opportunities.v1.RecentOpenedOpportunity.
 * Use `create(RecentOpenedOpportunitySchema)` to create a new message.
 */
export const RecentOpenedOpportunitySchema: GenMessage<RecentOpenedOpportunity> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 2);

/**
 * Direction analysis opinion structure
 *
 * @generated from message upside.opportunities.v1.DirectionAnalysisOpinion
 */
export type DirectionAnalysisOpinion = Message<"upside.opportunities.v1.DirectionAnalysisOpinion"> & {
  /**
   * @generated from field: string opinion = 1;
   */
  opinion: string;

  /**
   * @generated from field: optional string assist_touchpoint_id = 2;
   */
  assistTouchpointId?: string;

  /**
   * @generated from field: optional string primary_touchpoint_id = 3;
   */
  primaryTouchpointId?: string;
};

/**
 * Describes the message upside.opportunities.v1.DirectionAnalysisOpinion.
 * Use `create(DirectionAnalysisOpinionSchema)` to create a new message.
 */
export const DirectionAnalysisOpinionSchema: GenMessage<DirectionAnalysisOpinion> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 3);

/**
 * Direction analysis touchpoint citation
 *
 * @generated from message upside.opportunities.v1.DirectionAnalysisTouchpoint
 */
export type DirectionAnalysisTouchpoint = Message<"upside.opportunities.v1.DirectionAnalysisTouchpoint"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string date = 2;
   */
  date?: string;

  /**
   * @generated from field: optional string type = 3;
   */
  type?: string;

  /**
   * @generated from field: optional string detail = 4;
   */
  detail?: string;

  /**
   * @generated from field: optional string reason = 5;
   */
  reason?: string;
};

/**
 * Describes the message upside.opportunities.v1.DirectionAnalysisTouchpoint.
 * Use `create(DirectionAnalysisTouchpointSchema)` to create a new message.
 */
export const DirectionAnalysisTouchpointSchema: GenMessage<DirectionAnalysisTouchpoint> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 4);

/**
 * Direction analysis other citation
 *
 * @generated from message upside.opportunities.v1.DirectionAnalysisOtherCitation
 */
export type DirectionAnalysisOtherCitation = Message<"upside.opportunities.v1.DirectionAnalysisOtherCitation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string field = 2;
   */
  field?: string;

  /**
   * @generated from field: optional string detail = 3;
   */
  detail?: string;

  /**
   * @generated from field: optional string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message upside.opportunities.v1.DirectionAnalysisOtherCitation.
 * Use `create(DirectionAnalysisOtherCitationSchema)` to create a new message.
 */
export const DirectionAnalysisOtherCitationSchema: GenMessage<DirectionAnalysisOtherCitation> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 5);

/**
 * Complete direction analysis for an opportunity
 *
 * @generated from message upside.opportunities.v1.DirectionAnalysis
 */
export type DirectionAnalysis = Message<"upside.opportunities.v1.DirectionAnalysis"> & {
  /**
   * @generated from field: string opportunity_id = 1;
   */
  opportunityId: string;

  /**
   * INBOUND, OUTBOUND, UNDETERMINED
   *
   * @generated from field: optional string value = 2;
   */
  value?: string;

  /**
   * @generated from field: optional upside.opportunities.v1.DirectionAnalysisOpinion opinion = 3;
   */
  opinion?: DirectionAnalysisOpinion;

  /**
   * @generated from field: repeated upside.opportunities.v1.DirectionAnalysisTouchpoint touchpoint_citations = 4;
   */
  touchpointCitations: DirectionAnalysisTouchpoint[];

  /**
   * @generated from field: repeated upside.opportunities.v1.DirectionAnalysisOtherCitation other_citations = 5;
   */
  otherCitations: DirectionAnalysisOtherCitation[];

  /**
   * Analysis task ID for retry functionality
   *
   * @generated from field: optional string task_id = 6;
   */
  taskId?: string;
};

/**
 * Describes the message upside.opportunities.v1.DirectionAnalysis.
 * Use `create(DirectionAnalysisSchema)` to create a new message.
 */
export const DirectionAnalysisSchema: GenMessage<DirectionAnalysis> = /*@__PURE__*/
  messageDesc(file_upside_opportunities_v1_opportunities, 6);

